import styled from 'styled-components'

import { colors } from '../../styles/colors'

export const Container = styled.div`
  display: flex;
  max-height: 220px;
  min-height: 220px;
  padding: 21px 16px;
  width: 100%;
  background-color: ${colors.white};
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: #e3e3e3;
  }
`
